import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';

import { cx } from '@emotion/css';

import styles from './ThankYouView.module.scss';

type Props = {
  payment_intent: string;
  onSubmit: (callback: any) => Promise<void>;
};

export const ThankYouView = (props: Props) => {
  const { payment_intent } = props;
  const [isSubmitting, setIsSubmitting] = useState<boolean | null>(null);

  // console.log(flowData);
  useEffect(() => {
    if (payment_intent) {
      setIsSubmitting(true);
      //TODO: Add stripe_customer_id to the database
      props.onSubmit(setIsSubmitting(false));
    }
  }, [payment_intent]);

  const confimMessage = () => {
    if (isSubmitting === false) {
      return 'Success! Payment received. \nCheck your email for the Payment Confirmation.';
    } else {
      return 'Please wait while we process your request';
    }
  };
  return (
    <section className={styles.thank_you_section}>
      <div className={styles.thank_you_banner}>
        <div className={styles.banner_imgs}>
          <Image
            alt="thank you dog"
            src="/images/thankyou.gif"
            className={styles.thank_you_gif}
            width={440}
            height={195.03}
          />
        </div>
      </div>
      <div className={styles.thank_you_wrap}>
        <div className={styles.container}>
          <div className={styles.thank_inner}>
            <h5 className={styles.thank_title}>Thank you!</h5>
            <p className={styles.thank_text}>{confimMessage()}</p>
            <Link href={'/'} className={cx(styles.ct_btn, styles.back_home)}>
              Back to home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
